import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS } from '../../styles/variables';

export const VehicleDetailsPageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 320px;
  flex-shrink: 0;
  width: calc(100% - 32px);
  margin: 0 auto 0px auto;
  @media ${device.mobileM} {
    width: calc(100% - 56px);
    margin: 0 auto 0px auto;
  }
  @media ${device.tablet} {
    width: calc(100% - 120px);
    margin: 0 auto 96px auto;
  }
  @media ${device.laptopL} {
    width: calc(100% - 192px);
    margin: 0 auto 96px auto;
  }
  @media ${device.desktop} {
    width: 100%;
    max-width: 1248px;
    margin: 0 auto 96px auto;
  }
`;

export const Wrapper = styled(VehicleDetailsPageWrapper)`
  .react-loading-skeleton {
    height: 346px;
    /* margin-top: 20px; */
  }
  @media ${device.mobileL} {
    .react-loading-skeleton {
      height: 350px;
    }
  }
  @media ${device.tablet} {
    margin-bottom: 90px;
    .react-loading-skeleton {
      height: 308px;
    }
  }
  @media ${device.laptopM} {
    .react-loading-skeleton {
      height: 202px;
    }
  }
`;
export const BackgroundColorWrap = styled.div`
  background-color: ${COLORS.white};
`;
